import { getData, getPaged, patchData, postData, type Paged } from './client'
import type {
  BulkDecideResult,
  CorrectionKind,
  CorrectionRequestItem,
  CorrectionStatus,
  CorrectionSubmitRequest,
} from './types'

export interface MineFilter {
  status?: CorrectionStatus | null
  page?: number
}

export function mine(filter: MineFilter): Promise<Paged<CorrectionRequestItem>> {
  return getPaged<CorrectionRequestItem>('/correction-requests/mine', { params: filter })
}

export interface InboxFilter {
  status?: CorrectionStatus | null
  from?: string
  to?: string
  employeeId?: number | null
  workSiteId?: number | null
  department?: string | null
  kind?: CorrectionKind | null
  page?: number
}

export function inbox(filter: InboxFilter): Promise<Paged<CorrectionRequestItem>> {
  return getPaged<CorrectionRequestItem>('/correction-requests', { params: filter })
}

export function inboxCounts(): Promise<Record<CorrectionStatus, number>> {
  return getData<Record<CorrectionStatus, number>>('/correction-requests/inbox-count')
}

export function detail(id: number): Promise<CorrectionRequestItem> {
  return getData<CorrectionRequestItem>(`/correction-requests/${id}`)
}

export function submit(body: CorrectionSubmitRequest): Promise<CorrectionRequestItem> {
  return postData<CorrectionRequestItem>('/correction-requests', body)
}

export function update(
  id: number,
  body: Partial<CorrectionSubmitRequest>,
): Promise<CorrectionRequestItem> {
  return patchData<CorrectionRequestItem>(`/correction-requests/${id}`, body)
}

export function cancel(id: number): Promise<CorrectionRequestItem> {
  return postData<CorrectionRequestItem>(`/correction-requests/${id}/cancel`)
}

export interface DecisionBody {
  reviewerNotes?: string | null
  /** 큰 차이(기본 4시간)를 승인할 때 한 번 더 확인했다는 표시 */
  confirmLargeDiff?: boolean
}

export function approve(id: number, body: DecisionBody = {}): Promise<CorrectionRequestItem> {
  return postData<CorrectionRequestItem>(`/correction-requests/${id}/approve`, body)
}

export function reject(id: number, body: DecisionBody = {}): Promise<CorrectionRequestItem> {
  return postData<CorrectionRequestItem>(`/correction-requests/${id}/reject`, body)
}

export function bulkDecide(
  ids: number[],
  decision: 'approve' | 'reject',
  body: DecisionBody = {},
): Promise<BulkDecideResult> {
  return postData<BulkDecideResult>('/correction-requests/bulk-decide', {
    ids,
    decision,
    ...body,
  })
}
